import { axios } from '@/utils/request'

/**
 * 获取积分列表
 *
 * @author 张禹尧
 * @date 2022-04-15 09:33:15
 */
export function baUserPointsPage (parameter) {
  return axios({
    url: '/baUserPoints/page',
    method: 'get',
    params: parameter
  })
}
/**
 * 发送奖励
 *
 * @author 张禹尧
 * @date 2022-04-15 09:33:15
 */
export function sendRewardSingle (parameter) {
  return axios({
    url: '/baUserPointsReward/sendReward',
    method: 'post',
    data: parameter
  })
}
/**
 * 批量发送奖励
 *
 * @author 张禹尧
 * @date 2022-04-15 09:33:15
 */
export function batchSendRewardBatch (parameter) {
  return axios({
    url: '/baUserPointsReward/batchSendReward',
    method: 'post',
    data: parameter
  })
}